import { ServiceBase, IBaseEntity } from './ServiceBase';
import { post } from '../ReaderlyHttpClient';

export interface Publisher extends IBaseEntity {}

export class PublishersService extends ServiceBase<Publisher> {
  constructor() {
    super('publishers');
  }

  async GetFiltered(searchString?: string, authorIds?: number[]) {
    const request = {
      search: searchString ?? '',
      authors: authorIds ?? [],
      pageCount: 100
    };
    return await post<Publisher[], typeof request>('publishers/filters', request);
  }

  async Create(name: string) {
    return await post<Publisher, { name: string }>('admin/publishers', { name });
  }
}

const publishersServiceInstance = new PublishersService();
export default publishersServiceInstance;
